import { gql } from 'graphql-tag'
import fragmentEventAgendaSectionItem from '../event-agenda-section-item/fragment-event-agenda-section-item'

export default gql`
  ${fragmentEventAgendaSectionItem}
  fragment EventAgendaSectionFragment on EventAgendaSection {
    contentType: __typename
    sys {
      id
    }
    title
    agendaSectionItemsCollection {
      items {
        ...EventAgendaSectionItemFragment
      }
    }
  }
`
